import { createWebHistory, createRouter } from "vue-router";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import ExpositorSection from "@/components/ExpositorSection.vue";
import AcreditadoSection from "@/components/AcreditadoSection.vue";
import AcreditadoSectionInsitu from "@/components/AcreditadoSectionInsitu.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import InstitucionesSection from "@/components/InstitucionesSection.vue";

const routes = [
  {
    path: "/",
    component: AcreditadoSectionInsitu,
  },

  {
    path: "/instituciones",
    component: InstitucionesSection,
  },
  {
    path: "/expositores",
    component: ExpositorSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;